import * as React from 'react';
import { withRouter, RouteComponentProps, Route } from 'react-router-dom';
import { Container, Title, Section, Button } from '../modules/modules';
import CountryService from '..//services/CountryService';

interface IErrorPageProps extends RouteComponentProps<{
  language: string; orderNumber: string | undefined
}> {
  title?: string;
  description?: string;
}

class ErrorPage extends React.Component<IErrorPageProps> {
  renderError() {
    const { title, description } = this.props;
    const { language } = CountryService.GetInstance();

    return (
      <main>
        <Section type="borderTop pt-10-force mb-6">
          <Container type="xs">
            <div className="text-center">
              <Title>
                {title || `Stránka nebyla nalezena`}
              </Title>
              <div className="text-error mt-4">{description || '#404'}</div>
              <div className="mt-5 mt-3-md">
                <Button
                  onClick={() =>
                    this.props.history.push(`/${language}/`)
                  }
                  color="trans"
                  size="lg"
                >
                  Go to homepage
                </Button>
              </div>
            </div>
          </Container>
        </Section>
        <div className="borderTop" />
      </main>
    );
  }

  render() {
    return <Route
      render={({staticContext}) => {
        if (staticContext) {
          staticContext.statusCode = 404;
        }
        return this.renderError();
      }}
    />;
  }
}

export default withRouter(ErrorPage);



// WEBPACK FOOTER //
// ./src/pages/ErrorPage.tsx